var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "19px",
    viewBox: "0 0 23 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webbsite-1.0",
    transform: "translate(-175.000000, -976.000000)",
    fill: "#6C6C6C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(175.793952, 976.275420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.699932,18.488976 C6.699932,18.501972 6.699248,18.513448 6.698108,18.522872 C6.68914,18.519984 6.678652,18.514968 6.666796,18.509192 L0.19038,15.270984 C0.099712,15.225612 -5.77315973e-15,15.06434 -5.77315973e-15,14.962804 L0.00038,0.115824 L6.699932,3.465676 L6.699932,18.488976 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "7.517388 11.417252 7.517388 4.657204 13.526632 14.421456"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.196616 7.451192 14.801912 -5.59552404e-14 21.560896 3.37934 14.625516 14.649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.73334,18.484036 C21.73334,18.496956 21.73258,18.508508 21.731516,18.517856 C21.722548,18.514284 21.71206,18.509952 21.700584,18.504176 L15.210108,15.259508 L21.73334,4.658648 L21.73334,18.484036 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/medium_icon.f58c5131f1b15ccc9cc3ab963e6f811b.svg";
export { ForwardRef as ReactComponent };